import L from "./index752.js";
import { resolveComponent as f, resolveDirective as B, withDirectives as I, openBlock as s, createElementBlock as a, mergeProps as h, toHandlerKey as P, createVNode as b, withCtx as t, withModifiers as S, normalizeClass as n, renderSlot as u, createCommentVNode as i, createBlock as d, Fragment as m, renderList as y, vShow as H, createElementVNode as r, toDisplayString as v, normalizeStyle as $, createTextVNode as z, resolveDynamicComponent as T } from "vue";
import K from "./index720.js";
const N = ["id", "value", "name", "disabled", "autocomplete", "tabindex", "readonly", "aria-activedescendant", "aria-controls", "aria-expanded", "aria-label"], F = ["textContent"], U = { key: 1 };
function A(e, o, j, q, G, J) {
  const k = f("el-tag"), c = f("el-tooltip"), C = f("el-icon"), w = f("el-option"), R = f("el-option-group"), D = f("el-options"), M = f("el-scrollbar"), O = f("el-select-menu"), E = B("click-outside");
  return I((s(), a(
    "div",
    h({
      ref: "selectRef",
      class: [e.nsSelect.b(), e.nsSelect.m(e.selectSize)]
    }, {
      [P(e.mouseEnterEventName)]: o[10] || (o[10] = (p) => e.states.inputHovering = !0)
    }, {
      onMouseleave: o[11] || (o[11] = (p) => e.states.inputHovering = !1)
    }),
    [
      b(c, {
        ref: "tooltipRef",
        visible: e.dropdownMenuVisible,
        placement: e.placement,
        teleported: e.teleported,
        "popper-class": [e.nsSelect.e("popper"), e.popperClass],
        "popper-style": e.popperStyle,
        "popper-options": e.popperOptions,
        "fallback-placements": e.fallbackPlacements,
        effect: e.effect,
        pure: "",
        trigger: "click",
        transition: `${e.nsSelect.namespace.value}-zoom-in-top`,
        "stop-popper-mouse-event": !1,
        "gpu-acceleration": !1,
        persistent: e.persistent,
        "append-to": e.appendTo,
        "show-arrow": e.showArrow,
        offset: e.offset,
        onBeforeShow: e.handleMenuEnter,
        onHide: o[9] || (o[9] = (p) => e.states.isBeforeHide = !1)
      }, {
        default: t(() => {
          var p;
          return [
            r(
              "div",
              {
                ref: "wrapperRef",
                class: n([
                  e.nsSelect.e("wrapper"),
                  e.nsSelect.is("focused", e.isFocused),
                  e.nsSelect.is("hovering", e.states.inputHovering),
                  e.nsSelect.is("filterable", e.filterable),
                  e.nsSelect.is("disabled", e.selectDisabled)
                ]),
                onClick: o[6] || (o[6] = S((...l) => e.toggleMenu && e.toggleMenu(...l), ["prevent"]))
              },
              [
                e.$slots.prefix ? (s(), a(
                  "div",
                  {
                    key: 0,
                    ref: "prefixRef",
                    class: n(e.nsSelect.e("prefix"))
                  },
                  [
                    u(e.$slots, "prefix")
                  ],
                  2
                  /* CLASS */
                )) : i("v-if", !0),
                r(
                  "div",
                  {
                    ref: "selectionRef",
                    class: n([
                      e.nsSelect.e("selection"),
                      e.nsSelect.is(
                        "near",
                        e.multiple && !e.$slots.prefix && !!e.states.selected.length
                      )
                    ])
                  },
                  [
                    e.multiple ? u(e.$slots, "tag", {
                      key: 0,
                      data: e.states.selected,
                      deleteTag: e.deleteTag,
                      selectDisabled: e.selectDisabled
                    }, () => [
                      (s(!0), a(
                        m,
                        null,
                        y(e.showTagList, (l) => (s(), a(
                          "div",
                          {
                            key: e.getValueKey(l),
                            class: n(e.nsSelect.e("selected-item"))
                          },
                          [
                            b(k, {
                              closable: !e.selectDisabled && !l.isDisabled,
                              size: e.collapseTagSize,
                              type: e.tagType,
                              effect: e.tagEffect,
                              "disable-transitions": "",
                              style: $(e.tagStyle),
                              onClose: (g) => e.deleteTag(g, l)
                            }, {
                              default: t(() => [
                                r(
                                  "span",
                                  {
                                    class: n(e.nsSelect.e("tags-text"))
                                  },
                                  [
                                    u(e.$slots, "label", {
                                      index: l.index,
                                      label: l.currentLabel,
                                      value: l.value
                                    }, () => [
                                      z(
                                        v(l.currentLabel),
                                        1
                                        /* TEXT */
                                      )
                                    ])
                                  ],
                                  2
                                  /* CLASS */
                                )
                              ]),
                              _: 2
                              /* DYNAMIC */
                            }, 1032, ["closable", "size", "type", "effect", "style", "onClose"])
                          ],
                          2
                          /* CLASS */
                        ))),
                        128
                        /* KEYED_FRAGMENT */
                      )),
                      e.collapseTags && e.states.selected.length > e.maxCollapseTags ? (s(), d(c, {
                        key: 0,
                        ref: "tagTooltipRef",
                        disabled: e.dropdownMenuVisible || !e.collapseTagsTooltip,
                        "fallback-placements": ["bottom", "top", "right", "left"],
                        effect: e.effect,
                        placement: "bottom",
                        "popper-class": e.popperClass,
                        "popper-style": e.popperStyle,
                        teleported: e.teleported,
                        "popper-options": e.popperOptions
                      }, {
                        default: t(() => [
                          r(
                            "div",
                            {
                              ref: "collapseItemRef",
                              class: n(e.nsSelect.e("selected-item"))
                            },
                            [
                              b(k, {
                                closable: !1,
                                size: e.collapseTagSize,
                                type: e.tagType,
                                effect: e.tagEffect,
                                "disable-transitions": "",
                                style: $(e.collapseTagStyle)
                              }, {
                                default: t(() => [
                                  r(
                                    "span",
                                    {
                                      class: n(e.nsSelect.e("tags-text"))
                                    },
                                    " + " + v(e.states.selected.length - e.maxCollapseTags),
                                    3
                                    /* TEXT, CLASS */
                                  )
                                ]),
                                _: 1
                                /* STABLE */
                              }, 8, ["size", "type", "effect", "style"])
                            ],
                            2
                            /* CLASS */
                          )
                        ]),
                        content: t(() => [
                          r(
                            "div",
                            {
                              ref: "tagMenuRef",
                              class: n(e.nsSelect.e("selection"))
                            },
                            [
                              (s(!0), a(
                                m,
                                null,
                                y(e.collapseTagList, (l) => (s(), a(
                                  "div",
                                  {
                                    key: e.getValueKey(l),
                                    class: n(e.nsSelect.e("selected-item"))
                                  },
                                  [
                                    b(k, {
                                      class: "in-tooltip",
                                      closable: !e.selectDisabled && !l.isDisabled,
                                      size: e.collapseTagSize,
                                      type: e.tagType,
                                      effect: e.tagEffect,
                                      "disable-transitions": "",
                                      onClose: (g) => e.deleteTag(g, l)
                                    }, {
                                      default: t(() => [
                                        r(
                                          "span",
                                          {
                                            class: n(e.nsSelect.e("tags-text"))
                                          },
                                          [
                                            u(e.$slots, "label", {
                                              index: l.index,
                                              label: l.currentLabel,
                                              value: l.value
                                            }, () => [
                                              z(
                                                v(l.currentLabel),
                                                1
                                                /* TEXT */
                                              )
                                            ])
                                          ],
                                          2
                                          /* CLASS */
                                        )
                                      ]),
                                      _: 2
                                      /* DYNAMIC */
                                    }, 1032, ["closable", "size", "type", "effect", "onClose"])
                                  ],
                                  2
                                  /* CLASS */
                                ))),
                                128
                                /* KEYED_FRAGMENT */
                              ))
                            ],
                            2
                            /* CLASS */
                          )
                        ]),
                        _: 3
                        /* FORWARDED */
                      }, 8, ["disabled", "effect", "popper-class", "popper-style", "teleported", "popper-options"])) : i("v-if", !0)
                    ]) : i("v-if", !0),
                    r(
                      "div",
                      {
                        class: n([
                          e.nsSelect.e("selected-item"),
                          e.nsSelect.e("input-wrapper"),
                          e.nsSelect.is("hidden", !e.filterable || e.selectDisabled)
                        ])
                      },
                      [
                        r("input", {
                          id: e.inputId,
                          ref: "inputRef",
                          value: e.states.inputValue,
                          type: "text",
                          name: e.name,
                          class: n([e.nsSelect.e("input"), e.nsSelect.is(e.selectSize)]),
                          disabled: e.selectDisabled,
                          autocomplete: e.autocomplete,
                          style: $(e.inputStyle),
                          tabindex: e.tabindex,
                          role: "combobox",
                          readonly: !e.filterable,
                          spellcheck: "false",
                          "aria-activedescendant": ((p = e.hoverOption) == null ? void 0 : p.id) || "",
                          "aria-controls": e.contentId,
                          "aria-expanded": e.dropdownMenuVisible,
                          "aria-label": e.ariaLabel,
                          "aria-autocomplete": "none",
                          "aria-haspopup": "listbox",
                          onKeydown: o[0] || (o[0] = (...l) => e.handleKeydown && e.handleKeydown(...l)),
                          onCompositionstart: o[1] || (o[1] = (...l) => e.handleCompositionStart && e.handleCompositionStart(...l)),
                          onCompositionupdate: o[2] || (o[2] = (...l) => e.handleCompositionUpdate && e.handleCompositionUpdate(...l)),
                          onCompositionend: o[3] || (o[3] = (...l) => e.handleCompositionEnd && e.handleCompositionEnd(...l)),
                          onInput: o[4] || (o[4] = (...l) => e.onInput && e.onInput(...l)),
                          onClick: o[5] || (o[5] = S((...l) => e.toggleMenu && e.toggleMenu(...l), ["stop"]))
                        }, null, 46, N),
                        e.filterable ? (s(), a("span", {
                          key: 0,
                          ref: "calculatorRef",
                          "aria-hidden": "true",
                          class: n(e.nsSelect.e("input-calculator")),
                          textContent: v(e.states.inputValue)
                        }, null, 10, F)) : i("v-if", !0)
                      ],
                      2
                      /* CLASS */
                    ),
                    e.shouldShowPlaceholder ? (s(), a(
                      "div",
                      {
                        key: 1,
                        class: n([
                          e.nsSelect.e("selected-item"),
                          e.nsSelect.e("placeholder"),
                          e.nsSelect.is(
                            "transparent",
                            !e.hasModelValue || e.expanded && !e.states.inputValue
                          )
                        ])
                      },
                      [
                        e.hasModelValue ? u(e.$slots, "label", {
                          key: 0,
                          index: e.getOption(e.modelValue).index,
                          label: e.currentPlaceholder,
                          value: e.modelValue
                        }, () => [
                          r(
                            "span",
                            null,
                            v(e.currentPlaceholder),
                            1
                            /* TEXT */
                          )
                        ]) : (s(), a(
                          "span",
                          U,
                          v(e.currentPlaceholder),
                          1
                          /* TEXT */
                        ))
                      ],
                      2
                      /* CLASS */
                    )) : i("v-if", !0)
                  ],
                  2
                  /* CLASS */
                ),
                r(
                  "div",
                  {
                    ref: "suffixRef",
                    class: n(e.nsSelect.e("suffix"))
                  },
                  [
                    e.iconComponent && !e.showClearBtn ? (s(), d(C, {
                      key: 0,
                      class: n([e.nsSelect.e("caret"), e.nsSelect.e("icon"), e.iconReverse])
                    }, {
                      default: t(() => [
                        (s(), d(T(e.iconComponent)))
                      ]),
                      _: 1
                      /* STABLE */
                    }, 8, ["class"])) : i("v-if", !0),
                    e.showClearBtn && e.clearIcon ? (s(), d(C, {
                      key: 1,
                      class: n([
                        e.nsSelect.e("caret"),
                        e.nsSelect.e("icon"),
                        e.nsSelect.e("clear")
                      ]),
                      onClick: e.handleClearClick
                    }, {
                      default: t(() => [
                        (s(), d(T(e.clearIcon)))
                      ]),
                      _: 1
                      /* STABLE */
                    }, 8, ["class", "onClick"])) : i("v-if", !0),
                    e.validateState && e.validateIcon && e.needStatusIcon ? (s(), d(C, {
                      key: 2,
                      class: n([
                        e.nsInput.e("icon"),
                        e.nsInput.e("validateIcon"),
                        e.nsInput.is("loading", e.validateState === "validating")
                      ])
                    }, {
                      default: t(() => [
                        (s(), d(T(e.validateIcon)))
                      ]),
                      _: 1
                      /* STABLE */
                    }, 8, ["class"])) : i("v-if", !0)
                  ],
                  2
                  /* CLASS */
                )
              ],
              2
              /* CLASS */
            )
          ];
        }),
        content: t(() => [
          b(
            O,
            { ref: "menuRef" },
            {
              default: t(() => [
                e.$slots.header ? (s(), a(
                  "div",
                  {
                    key: 0,
                    class: n(e.nsSelect.be("dropdown", "header")),
                    onClick: o[7] || (o[7] = S(() => {
                    }, ["stop"]))
                  },
                  [
                    u(e.$slots, "header")
                  ],
                  2
                  /* CLASS */
                )) : i("v-if", !0),
                I(b(M, {
                  id: e.contentId,
                  ref: "scrollbarRef",
                  tag: "ul",
                  "wrap-class": e.nsSelect.be("dropdown", "wrap"),
                  "view-class": e.nsSelect.be("dropdown", "list"),
                  class: n([e.nsSelect.is("empty", e.filteredOptionsCount === 0)]),
                  role: "listbox",
                  "aria-label": e.ariaLabel,
                  "aria-orientation": "vertical",
                  onScroll: e.popupScroll
                }, {
                  default: t(() => [
                    e.showNewOption ? (s(), d(w, {
                      key: 0,
                      value: e.states.inputValue,
                      created: !0
                    }, null, 8, ["value"])) : i("v-if", !0),
                    b(D, null, {
                      default: t(() => [
                        u(e.$slots, "default", {}, () => [
                          (s(!0), a(
                            m,
                            null,
                            y(e.options, (p, l) => {
                              var g;
                              return s(), a(
                                m,
                                { key: l },
                                [
                                  (g = e.getOptions(p)) != null && g.length ? (s(), d(R, {
                                    key: 0,
                                    label: e.getLabel(p),
                                    disabled: e.getDisabled(p)
                                  }, {
                                    default: t(() => [
                                      (s(!0), a(
                                        m,
                                        null,
                                        y(e.getOptions(p), (V) => (s(), d(
                                          w,
                                          h({
                                            key: e.getValue(V)
                                          }, { ref_for: !0 }, e.getOptionProps(V)),
                                          null,
                                          16
                                          /* FULL_PROPS */
                                        ))),
                                        128
                                        /* KEYED_FRAGMENT */
                                      ))
                                    ]),
                                    _: 2
                                    /* DYNAMIC */
                                  }, 1032, ["label", "disabled"])) : (s(), d(
                                    w,
                                    h({
                                      key: 1,
                                      ref_for: !0
                                    }, e.getOptionProps(p)),
                                    null,
                                    16
                                    /* FULL_PROPS */
                                  ))
                                ],
                                64
                                /* STABLE_FRAGMENT */
                              );
                            }),
                            128
                            /* KEYED_FRAGMENT */
                          ))
                        ])
                      ]),
                      _: 3
                      /* FORWARDED */
                    })
                  ]),
                  _: 3
                  /* FORWARDED */
                }, 8, ["id", "wrap-class", "view-class", "class", "aria-label", "onScroll"]), [
                  [H, e.states.options.size > 0 && !e.loading]
                ]),
                e.$slots.loading && e.loading ? (s(), a(
                  "div",
                  {
                    key: 1,
                    class: n(e.nsSelect.be("dropdown", "loading"))
                  },
                  [
                    u(e.$slots, "loading")
                  ],
                  2
                  /* CLASS */
                )) : e.loading || e.filteredOptionsCount === 0 ? (s(), a(
                  "div",
                  {
                    key: 2,
                    class: n(e.nsSelect.be("dropdown", "empty"))
                  },
                  [
                    u(e.$slots, "empty", {}, () => [
                      r(
                        "span",
                        null,
                        v(e.emptyText),
                        1
                        /* TEXT */
                      )
                    ])
                  ],
                  2
                  /* CLASS */
                )) : i("v-if", !0),
                e.$slots.footer ? (s(), a(
                  "div",
                  {
                    key: 3,
                    class: n(e.nsSelect.be("dropdown", "footer")),
                    onClick: o[8] || (o[8] = S(() => {
                    }, ["stop"]))
                  },
                  [
                    u(e.$slots, "footer")
                  ],
                  2
                  /* CLASS */
                )) : i("v-if", !0)
              ]),
              _: 3
              /* FORWARDED */
            },
            512
            /* NEED_PATCH */
          )
        ]),
        _: 3
        /* FORWARDED */
      }, 8, ["visible", "placement", "teleported", "popper-class", "popper-style", "popper-options", "fallback-placements", "effect", "transition", "persistent", "append-to", "show-arrow", "offset", "onBeforeShow"])
    ],
    16
    /* FULL_PROPS */
  )), [
    [E, e.handleClickOutside, e.popperRef]
  ]);
}
var Y = /* @__PURE__ */ K(L, [["render", A]]);
export {
  Y as default
};
